import { useState } from "react";
import { FaHandHoldingUsd, FaHandsHelping, FaFileAlt, FaMoneyCheckAlt, FaIdCard } from "react-icons/fa";
import { Card, Carousel, CarouselIndicators, Modal } from "../components/carousel";

import icon_1 from "../assets/icons/Adli_Tip_Teknolojileri.png";
import icon_2 from "../assets/icons/Afetlere_Hazirlik.png";
import icon_3 from "../assets/icons/Akilli_Sehir.jpg";
import icon_4 from "../assets/icons/Biyometrik_Sistemler.png";
import icon_5 from "../assets/icons/Butunlesik_Guvenlik_Sistemler.png";
import icon_6 from "../assets/icons/Deprem_Oncesi_Sonrasi.png";
import icon_7 from "../assets/icons/Gozetleme.jpg";
import icon_8 from "../assets/icons/Iletisim_Haberlesme.jpg";
import icon_9 from "../assets/icons/Trafik.png";


const Anasayfa = () => {
  const [selectedCard, setSelectedCard] = useState(null);

  const cardData = [
  {
    alt: "Biyometrik Sistemler",
    title: "Biyometrik Sistemler",
    src: icon_4,
    description: 
      <ul class="list-group list-group-flush">
        <li class="list-group-item">Yüz Tanıma</li>
        <li class="list-group-item">Ses Tanıma</li>
        <li class="list-group-item">Jest Tanıma</li>
        <li class="list-group-item">Parmak İzi</li>
        <li class="list-group-item">Retina-İris</li>
        <li class="list-group-item">Yürüyüş Tanıma</li>
      </ul>
  },
  {
    alt: "Bütünleşik Güvenlik Sistemler",
    title: "Bütünleşik Güvenlik Sistemler",
    src: icon_5,
    description: 
      <ul class="list-group list-group-flush">
        <li class="list-group-item">Siber Güvenlik</li>
        <li class="list-group-item">Yapay Zekâ Uygulamaları</li>
        <li class="list-group-item">Sınır Güvenliği ve Göç Kontrol
          <ul class="list-group list-group-flush list-card">
            <li class="list-group-item">Sızma Tespit</li>
            <li class="list-group-item">Geçiş/Giriş Kontrol</li>
            <li class="list-group-item">Kimlik Doğrulama</li>
          </ul>
        </li>
        <li class="list-group-item">AI & Machine Learning</li>
        <li class="list-group-item">İstenmeyen Madde Tespiti</li>
        <li class="list-group-item">Patlayıcı Tespit ve İmha</li>
        <li class="list-group-item">Gelişmiş Sensör ve Tarayacılar</li>
        <li class="list-group-item">Blockchain Tabanlı Sistemler ve Kriptoloji</li>
      </ul>
  },
  {
    alt: "Akıllı Şehir",
    title: "Akıllı Şehir",
    src: icon_3,
    description: 
      <ul class="list-group list-group-flush">
        <li class="list-group-item">AI Destekli Karar Alma Altyapısı</li>
        <li class="list-group-item">AI Destekli Kentsel Tasarım</li>
        <li class="list-group-item">Ulaşım ve Güvenlikte Big Data Kullanımı</li>
        <li class="list-group-item">Ulaşım Güvenliği</li>
        <li class="list-group-item">Kritik Altyapı Güvenliği</li>
        <li class="list-group-item">IoT Destekli Network Bağlantılı Trafik Akış Yönetim Sistemi
          <ul class="list-group list-group-flush list-card">
            <li class="list-group-item">Akıllı Ulaşım</li>
            <li class="list-group-item">Akıllı Aydınlatma</li>
            <li class="list-group-item">Akıllı Trafik Işıkları</li>
            <li class="list-group-item">Akıllı Park</li>
          </ul>
        </li>
        <li class="list-group-item">Siber istihbarat ve Tehdit Tespiti</li>
        <li class="list-group-item">Mobil Güvenlik Sistemleri</li>
      </ul>
  },
  {
    alt: "İletişim ve Haberleşme ",
    title: "İletişim ve Haberleşme",
    src: icon_8,
    description: 
      <ul class="list-group list-group-flush">
        <li class="list-group-item">Güvenli Haberleşme</li>
        <li class="list-group-item">Kablosuz Haberleşme</li>
        <li class="list-group-item">Uydu Haberleşme</li>
        <li class="list-group-item">Güvenli Bulut</li>
        <li class="list-group-item">Bulut Tabanlı Veri Güvenliği</li>
        <li class="list-group-item">IoT Güvenliği</li>
        <li class="list-group-item">Güvenli Altyapı</li>
        <li class="list-group-item">Şifreleme</li>
        <li class="list-group-item">Temassız Erişim</li>
      </ul>
  },
  {
    alt: "Gözetleme",
    title: "Gözetleme",
    src: icon_7,
    description: 
      <ul class="list-group list-group-flush">
        <li class="list-group-item">Mobil Gözetleme</li>
        <li class="list-group-item">AI & Machine Learning</li>
        <li class="list-group-item">X-Ray Sistemleri</li>
        <li class="list-group-item">MM Dalga Sistemleri</li>
        <li class="list-group-item">Video</li>
      </ul>
  },
  {
    alt: "Adli Tıp Teknolojileri",
    title: "Adli Tıp Teknolojileri",
    src: icon_1,
    description: 
      <ul class="list-group list-group-flush">
        <li class="list-group-item">Olay Yeri İncelemesi</li>
        <li class="list-group-item">Adli Toksikoloji ve Zehirlenmeler</li>
        <li class="list-group-item">Trafik ve Sigorta Tıbbı</li>
        <li class="list-group-item">Kimlik Tespiti</li>
        <li class="list-group-item">Biyolojik Materyalin Kimliklendirilmesi</li>
        <li class="list-group-item">Adli Olgularda Giysi İncelemesi</li>
        <li class="list-group-item">Bilgisayar, İnternet ve Adli Tıp</li>
        <li class="list-group-item">Narkotik</li>
      </ul>
  },
  {
    alt: "Trafik",
    title: "Trafik",
    src: icon_9,
    description: 
      <ul class="list-group list-group-flush">
        <li class="list-group-item">Trafik Radarları</li>
        <li class="list-group-item">Akıllı-Güvenli Ulaşım</li>
        <li class="list-group-item">Akıllı Trafik Işıkları</li>
        <li class="list-group-item">Gelişmiş Sensörler</li>
        <li class="list-group-item">Plaka ve Araç Tanıma</li>
      </ul>
  },
  {
    alt: "Afetlere Hazırlık, Müdahale ve Afet Sonrası Yardım Yönetimi",
    title: "Afetlere Hazırlık ve Afet Sonrası Yardım Teknolojileri",
    src: icon_2,
    description: 
      <ul class="list-group list-group-flush">
        <li class="list-group-item">Önleyici Tedbirler</li>
        <li class="list-group-item">Etkin Denetleme Sistemleri</li>
        <li class="list-group-item">İHA ve Uydu Yer tespit Sistemleri</li>
        <li class="list-group-item">Simülasyonlar</li>
        <li class="list-group-item">Fiziksel Erişim Kontrol Sistemleri</li>
        <li class="list-group-item">Afet Sonrası Planlama</li>
      </ul>
  },
  {
    alt: "Deprem Öncesi ve Sonrası Önlemler",
    title: "Deprem Öncesi ve Sonrası Önlemler",
    src: icon_6,
    description: 
      <ul class="list-group list-group-flush">
        <li class="list-group-item">Hassas Haritalama</li>
        <li class="list-group-item">Erken Uyarı Sistemleri</li>
        <li class="list-group-item">Kişi Konum Tespit Teknolojileri</li>
        <li class="list-group-item">Duvar Arkası Görüntüleme Teknolojileri</li>
        <li class="list-group-item">IoT Destekli Deprem Sonrası Yardım Planlaması</li>
      </ul>
  }]

  return (
    <div className="mt-4 pt-4">
      
      <Carousel />

      <section className="my-4 py-4">
        <div className="row my-4 py-4 header-hero header-hero-top">
          <div className="col text-center">
            <h2>Odak Teknolojiler</h2>
          </div>
        </div>

        <div className="cards">
          {cardData.map((card, index) => (
            <Card
              key={index}
              alt={card.alt}
              src={card.src}
              title={card.title}
              onOpen={() => setSelectedCard(card)}
            />
          ))}
        </div>

        <Modal
          show={!!selectedCard}
          title={selectedCard?.title}
          description={selectedCard?.description}
          onClose={() => setSelectedCard(null)}
        />



        {/* <div className="cards">
          {cardData.map((card, index) => (
            <React.Fragment key={`card-${index}`}>
              <Card
                key={`card-${index}`}
                unique={index}
                alt={card.alt}
                src={card.src}
                title={card.title}
                description={card.description}
              />

              <Modal 
                unique={index}
                title={card.title}
                description={card.description}
              />
            </React.Fragment>
          ))}
        </div> */}
      </section>
      
      {/* <section className="my-4 py-4">
        <div className="row my-4 py-4 header-hero header-hero-top">
          <div className="col text-center">
            <h2>Haberler</h2>
          </div>
        </div>

        <CarouselIndicators />

      </section> */}

    </div>
  );
};

export default Anasayfa;
